<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="上一级分类：" prop="pid">
              <el-cascader
                v-model="formValidate.pid"
                class="selWidth"
                :options="appraisalCateList"
                :props="props"
                ref="refSubCat"
                clearable
                @change="handleChange($event)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分类名称：" prop="cate_name">
              <el-input v-model="formValidate.cate_name" />
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="图片：" prop="pic">
              <div
                class="upLoadPicBox"
                title="750*750px"
                @click="modalPicTap('1','pic')"
              >
                <div v-if="formValidate.pic" class="pictrue">
                  <img :src="formValidate.pic">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
<!--          <el-col :span="24" v-if = 'level == 1 && level_value'>-->
<!--            <el-form-item label="品牌首字母：" prop="brand_initial" >-->
<!--              <el-input v-model="formValidate.brand_initial"  />-->
<!--              <span>品牌名字的大写首字母，作用用字母排序</span>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="24" v-if = 'level == 2 && level_value'>
            <el-form-item label="商品规格：" props="spec_type">
              <el-radio-group
                v-model="formValidate.spec_type"
              >
<!--                <el-radio :label="0" class="radio">单规格</el-radio>-->
                <el-radio :label="1">多规格</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = 'level == 2 && level_value && formValidate.spec_type == 1'>
            <el-form-item v-if="!isBtn">
              <el-button
                type="primary"
                icon="md-add"
                class="mr15"
                @click="addBtn"
              >添加新规格</el-button>
            </el-form-item>
            <el-form-item v-if="formValidate.attr.length > 0">
              <div v-for="(item, index) in formValidate.attr" :key="index">
                <div class="acea-row row-middle">
                  <span class="mr5">{{ item.value }}</span>
                  <i
                    class="el-icon-circle-close"
                    @click="handleRemoveAttr(index)"
                  />
                </div>
                <div class="rulesBox">
                  <el-tag
                    v-for="(j, indexn) in item.detail"
                    :key="indexn"
                    closable
                    size="medium"
                    :disable-transitions="false"
                    class="mb5 mr10"
                    @close="handleClose(item.detail, indexn)"
                  >{{ j }}
                  </el-tag>
                  <el-input
                    v-if="item.inputVisible"
                    ref="saveTagInput"
                    v-model="item.detail.attrsVal"
                    class="input-new-tag"
                    size="small"
                    @keyup.enter.native="
                      createAttr(item.detail.attrsVal, index)
                    "
                    @blur="createAttr(item.detail.attrsVal, index)"
                  />
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput(item)"
                  >+ 添加</el-button>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="level == 2 && level_value && formValidate.spec_type == 1 && isBtn">
            <el-col :xl="6" :lg="9" :md="9" :sm="24" :xs="24">
              <el-form-item label="规格：">
                <el-input
                  v-model="formDynamic.attrsName"
                  placeholder="请输入规格"
                />
              </el-form-item>
            </el-col>
            <el-col :xl="6" :lg="9" :md="9" :sm="24" :xs="24">
              <el-form-item label="规格值：">
                <el-input
                  v-model="formDynamic.attrsVal"
                  placeholder="请输入规格值"
                />
              </el-form-item>
            </el-col>
            <el-col :xl="12" :lg="6" :md="6" :sm="24" :xs="24">
              <el-form-item class="noLeft">
                <el-button
                  type="primary"
                  class="mr15"
                  @click="createAttrName"
                >确定</el-button>
                <el-button @click="offAttrName">取消</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col
            v-if="level == 2 && level_value && formValidate.spec_type == 1 && formValidate.attr.length > 0"
            :span="24"
            class="noForm"
          >
            <el-form-item label="批量设置：" class="labeltop">
              <el-table
                :data="oneFormBatch"
                border
                class="tabNumWidth"
                size="mini"
              >

                <el-table-column
                  v-for="(item, iii) in attrValue"
                  :key="iii"
                  :label="formThead[iii].title"
                  align="center"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row[iii]"
                      :min="0"
                      class="priceBox"
                      controls-position="right"
                    />
                  </template>
                </el-table-column>

                <el-table-column align="center" label="操作" min-width="80">
                  <template>
                    <el-button
                      type="text"
                      class="submission"
                      @click="batchAdd"
                    >批量添加</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <!-- 多规格表格-->
            <el-form-item
              v-if="
                level == 2 && level_value && formValidate.spec_type == 1 && formValidate.attr.length > 0
              "
              class="labeltop"
              label="规格列表："
            >
              <el-table
                :data="ManyAttrValue"
                border
                class="tabNumWidth"
                size="mini"
              >
                <template v-if="manyTabDate">
                  <el-table-column
                    v-for="(item, iii) in manyTabDate"
                    :key="iii"
                    align="center"
                    :label="manyTabTit[iii].title"
                    min-width="80"
                  >
                    <template slot-scope="scope">
                      <span class="priceBox" v-text="scope.row[iii]" />
                    </template>
                  </el-table-column>
                </template>
                <el-table-column
                  v-for="(item, iii) in attrValue"
                  :key="iii"
                  :label="formThead[iii].title"
                  align="center"
                  min-width="120"
                >
                <template slot-scope="scope">
                  <div>
                      <el-input-number
                        v-model="scope.row[iii]"
                        :min="0"
                        class="priceBox"
                        controls-position="right"
                      />
                  </div>
                </template>
                </el-table-column>
                <el-table-column
                  key="3"
                  align="center"
                  label="操作"
                  min-width="80"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      class="submission"
                      @click="delAttrTable(scope.$index)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = 'level == 2 && level_value && formValidate.spec_type == 0'>
            <el-form-item label="回收价格：" prop="recovery_price" >
              <el-input v-model="formValidate.recovery_price"  />
              <span>填写回收价格</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否显示：">
              <el-select v-model="formValidate.is_show" clearable placeholder="请选择状态" >
                <el-option v-for="(item, index) in switchData" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序：">
              <el-input-number :min=0 v-model="formValidate.sort" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import * as constants from '@/libs/constants.js'
import {
  appraisalCategoryCreateApi, appraisalCategoryDetailApi, appraisalCategoryMenuListApi
} from "@/api/appraisal";
import {recoveryCategoryCreateApi, recoveryCategoryDetailApi, recoveryCategoryMenuListApi} from "@/api/recovery";
const defaultObj = {
  cate_name: '',
  pic: '',
  cate_value: [],
  sort: 0,
  is_show: 1,
  spec_type: 1,
  attr:[],
  attrValue: [
    {
      price: null,
    }
  ],
}
const objTitle = {
  price: {
    title: '回收价'
  }
}
export default {
  name: 'addCate',
  data() {
    return {
      props: { checkStrictly: true, emitPath: false},
      switchData: constants.switchStatus,
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      appraisalCateList: [],
      progress: 0,
      data: [],
      level: 0,
      level_value:0,
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      isBtn: false,
      attrVal: {
        price: null,
      },
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])], // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])], // 多规格
      formThead: Object.assign({}, objTitle),
      manyTabDate: {},
      attrInfo: {},
    }
  },
  computed: {
    attrValue() {
      const obj = Object.assign({}, this.attrVal)
      return obj
    },
    oneFormBatch() {
      const obj = [Object.assign({}, defaultObj.attrValue[0])]
      if (this.OneattrValue[0] && this.OneattrValue[0]['image']) { obj[0]['image'] = this.OneattrValue[0]['image'] }
      delete obj[0].bar_code
      return obj
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function(val) {
        if (this.formValidate.spec_type === 1) this.watCh(val)
      },
      immediate: false,
      deep: true
    },
    currentTab(newVal) {
      if (newVal == 5) {
        this.$nextTick(e=>{
          this.setSort()
        })
      }
    }

  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    if (this.$route.params.id && this.formValidate.spec_type === 1) {
      this.$watch('formValidate.attr', this.watCh)
    }
  },
  mounted() {
    this.formValidate.attr.map(item => {
      this.$set(item, 'inputVisible', false)
    })
    if (this.$route.params.id) {
      this.getRecoveryCategoryData()
    }else
    {
      this.formValidate.attr = [];
    }
    this.recoveryMenuCategory();

  },
  methods: {
    showInput(item) {
      this.$set(item, 'inputVisible', true)
    },
    // 删除规格
    handleRemoveAttr(index) {
      this.formValidate.attr.splice(index, 1)
      this.manyFormValidate.splice(index, 1)
    },
    // 删除属性
    handleClose(item, index) {
      item.splice(index, 1)
    },

    // 添加属性
    createAttr(num, idx) {
      if (num) {
        this.formValidate.attr[idx].detail.push(num);
        var hash = {};
        this.formValidate.attr[idx].detail = this.formValidate.attr[
          idx
          ].detail.reduce(function(item, next) {
          /* eslint-disable */
          hash[next] ? "" : (hash[next] = true && item.push(next));
          return item;
        }, []);
        this.formValidate.attr[idx].inputVisible = false;
      } else {
        this.$message.warning("请添加属性");
      }
    },
    // 批量添加
    batchAdd() {
      for (const val of this.ManyAttrValue) {
        console.log(this.oneFormBatch[0])
        if(this.oneFormBatch[0].price!= null)this.$set(val, 'price', this.oneFormBatch[0].price)
      }
    },
    setSort() {
      // ref一定跟table上面的ref一致
      const el = this.$refs.tableParameter.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody'
      )[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        // 监听拖拽事件结束时触发
        onEnd: evt => {
          this.elChangeExForArray(evt.oldIndex, evt.newIndex, this.formValidate.params)
        }
      })
    },
    watCh(val) {
      const tmp = {}
      const tmpTab = {}
      this.formValidate.attr.forEach((o, i) => {
        tmp['value' + i] = { title: o.value }
        tmpTab['value' + i] = ''
      })
      this.ManyAttrValue = this.attrFormat(val)
      this.ManyAttrValue.forEach((val, index) => {
        const key = Object.values(val.detail)
          .sort()
          .join('/')
        if (this.attrInfo[key]) this.ManyAttrValue[index] = this.attrInfo[key]
      })
      this.attrInfo = {}
      this.ManyAttrValue.forEach(val => {
        // this.attrInfo[Object.values(val.detail).sort().join('/')] = val
        if (val.detail !== 'undefined' && val.detail !== null) {
          this.attrInfo[
            Object.values(val.detail)
              .sort()
              .join('/')
            ] = val
        }
      })
      this.manyTabTit = tmp
      this.manyTabDate = tmpTab
      this.formThead = Object.assign({}, this.formThead, tmp)
    },
    attrFormat(arr) {
      let data = []
      const res = []
      return format(arr)

      function format(arr) {
        if (arr.length > 1) {
          arr.forEach((v, i) => {
            if (i === 0) data = arr[i]['detail']
            const tmp = []
            data.forEach(function(vv) {
              arr[i + 1] &&
              arr[i + 1]['detail'] &&
              arr[i + 1]['detail'].forEach(g => {
                const rep2 =
                  (i !== 0 ? '' : arr[i]['value'] + '_$_') +
                  vv +
                  '-$-' +
                  arr[i + 1]['value'] +
                  '_$_' +
                  g
                tmp.push(rep2)
                if (i === arr.length - 2) {
                  const rep4 = {
                    price: 0,
                  }
                  rep2.split('-$-').forEach((h, k) => {
                    const rep3 = h.split('_$_')
                    if (!rep4['detail']) rep4['detail'] = {}
                    rep4['detail'][rep3[0]] = rep3.length > 1 ? rep3[1] : ''
                  })
                  // if(rep4.detail !== 'undefined' && rep4.detail !== null){
                  Object.values(rep4.detail).forEach((v, i) => {
                    rep4['value' + i] = v
                  })
                  // }

                  res.push(rep4)
                }
              })
            })
            data = tmp.length ? tmp : []
          })
        } else {
          const dataArr = []
          arr.forEach((v, k) => {
            v['detail'].forEach((vv, kk) => {
              dataArr[kk] = v['value'] + '_' + vv
              res[kk] = {
                price: 0,
                detail: { [v['value']]: vv }
              }
              // if(res[kk].detail !== 'undefined' && res[kk].detail !== null){
              Object.values(res[kk].detail).forEach((v, i) => {
                res[kk]['value' + i] = v
              })
              // }
            })
          })
          data.push(dataArr.join('$&'))
        }
        return res
      }
    },
    // 取消
    offAttrName() {
      this.isBtn = false
    },
    // 添加规则名称
    createAttrName() {
      if (this.formDynamic.attrsName && this.formDynamic.attrsVal) {
        const data = {
          value: this.formDynamic.attrsName,
          detail: [this.formDynamic.attrsVal]
        }
        this.formValidate.attr.push(data)
        var hash = {}
        this.formValidate.attr = this.formValidate.attr.reduce(function(
            item,
            next
          ) {
            /* eslint-disable */
            hash[next.value] ? "" : (hash[next.value] = true && item.push(next));
            return item;
          },
          []);
        this.clearAttr();
        this.isBtn = false;
      } else {
        this.$message.warning("请添加完整的规格！");
      }
    },
    // 添加按钮
    addBtn() {
      this.clearAttr()
      this.isBtn = true
    },
    clearAttr() {
      this.formDynamic.attrsName = ''
      this.formDynamic.attrsVal = ''
    },
    handleChange(val)
    {
      this.level_value = val
      this.level = this.$refs['refSubCat'].getCheckedNodes()[0].level
    },
    // 商品分类；
    recoveryMenuCategory() {
      recoveryCategoryMenuListApi(2)
        .then((res) => {
          console.log(res.data)
          this.appraisalCateList = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    onAdd() {
      if(!this.data)
      {
        this.data = [];
      }
      let obj = { cate_value_name: "", cate_value_img:""};
      this.data.push(obj);
    },
    // 删除
    delSpecs(idx) {
      this.data.splice(idx, 1);
    },
    // 点击图
    modalPicTap(tit,num,i) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if(num == 'pic')
        {
          _this.formValidate.pic = img[0];
        }
        if(num == 'cate_value_img')
        {
          _this.data[i].cate_value_img = img[0];
        }

      }, tit);
    },
    // 获取数据
    getRecoveryCategoryData() {
      this.fullscreenLoading = true
      recoveryCategoryDetailApi(this.$route.params.id)
        .then(res => {
          console.log(res.data)
          this.formValidate =  res.data
          this.level = res.data.level
          this.level_value =  res.data.pid
          this.data = res.data.cate_value
          if (this.formValidate.spec_type === 1) {
            this.ManyAttrValue = res.data.attrValue;
            this.ManyAttrValue.forEach(val => {
              if (val.detail !== "undefined" && val.detail !== null) {
                this.attrInfo[
                  Object.values(val.detail)
                    .sort()
                    .join("/")
                  ] = val;
              }
            });
          }
          if(!res.data.attr)
          {
            this.formValidate.attr = [];
          }
          this.fullscreenLoading = false
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.cate_name) {
        this.$message.error('请填写品类名称')
        return false
      }
      // if (!this.formValidate.pic) {
      //   this.$message.error('请上传品类图片')
      //   return false
      // }
      if(this.level == 1 && this.formValidate.pid != 0)
      {
        // if (!this.formValidate.brand_sort_name) {
        //   this.$message.error('请填写品牌英文名字')
        //   return false
        // }
        // if (!this.formValidate.brand_initial) {
        //   this.$message.error('请填写品牌首字母')
        //   return false
        // }
      }
      this.formValidate.cate_value = this.data;
      this.formValidate.appraisal_category_id = this.$route.params.id;
      if (this.formValidate.spec_type === 1) {
        this.formValidate.attrValue = this.ManyAttrValue;
      } else {
        this.formValidate.attrValue = [];
        this.formValidate.attr = [];
      }
      recoveryCategoryCreateApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/recovery/category' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
